'use strict';

/**
 *  Load modules
 */
import './modules/slick.js';
import './modules/fancybox.min.js';
import echo from './modules/echo.js';
import './modules/menu.js';
import './modules/video.js';
import './modules/tabs.js';
import './modules/lazyload.js';
import './modules/slider.js';
import './modules/slider-swiper.js';
import './modules/general.js';
import './modules/accordion.js';
import '../scss/app.scss';
import WOW from 'wowjs';
$(document).ready(function () {
  echo('App ready');
  function preloader() {
    $('#preloader').remove();
  }
  setTimeout(preloader, 900);
  new WOW.WOW().init();
});